import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationComponent } from './organization/organization.component';
import {PaginatorModule} from 'primeng/paginator';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {TableModule} from 'primeng/table';

@NgModule({
  declarations: [OrganizationComponent],
  imports: [
    CommonModule,
    PaginatorModule,
    TableModule
  ],
  exports:[OrganizationComponent,PaginatorModule,TableModule]

})
export class SharedModule { }
